export enum DialogRefType {
  // Overlay dialogs
  OverlayDialog = "OverlayDialog",
  SettingsDialog = "SettingsDialog",
  GlassMagnifierDialog = "GlassMagnifierDialog",
  AudioDialog = "AudioDialog",
  // Start screen dialogs
  ChaptersDialog = "ChaptersDialog",
  FilesDialog = "FilesDialog",
  WorksheetDialog = "WorksheetDialog",
  ExpoInfoDialog = "ExpoInfoDialog",
  ExpoAuthorsDialog = "ExpoAuthorsDialog",
  ExpoAudioVersionDialog = "ExpoAudioVersionDialog",
  // Finish Screen dialogs
  ShareExpoDialog = "ShareExpoDialog",
  FinishAllFilesDialog = "FinishAllFilesDialog",
  FinishInfoDialog = "FinishInfoDialogs",
  RatingDialog = "RatingDialog",
  // GENERAL DIALOGS
  InformationDialog = "InformationDialog",
  // Landing Page Dialogs
  RegisterDialog = "RegisterDialog",
  LoginDialog = "LoginDialog",
}
